<template>
  <div>
    <WithPagination :is-loading="isLoading" :data="negativeKeywords">
      <template slot-scope="{ currentPageData }">
        <ElTable :data="currentPageData" stripe>
          <ElTableColumn
            prop="keyword"
            :label="$t('ADVERTISEMENT.NEGATIVE_KEYWORDS.KEYWORD')"
          />
          <ElTableColumn :label="$t('ADVERTISEMENT.BID.MATCH_TYPE')">
            <template slot-scope="{ row: { matchingType } }">
              {{ translateNegativeMatchingTypes(matchingType) }}
            </template>
          </ElTableColumn>
          <ElTableColumn align="center">
            <template slot-scope="{ row: { id } }">
              <DeleteNegativeKeywordButton :id="id" @deleted="deleted" />
            </template>
          </ElTableColumn>
        </ElTable>
      </template>
    </WithPagination>
  </div>
</template>

<script>
import WithPagination from '@@/common/paginations/WithPagination';

import DeleteNegativeKeywordButton from './DeleteNegativeKeywordButton';
import translateNegativeMatchingTypes from './translateNegativeMatchingTypes';

export default {
  name: 'NegativeKeywordsList',
  components: {
    WithPagination,
    DeleteNegativeKeywordButton,
  },
  props: {
    negativeKeywords: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    translateNegativeMatchingTypes,
    deleted(id) {
      this.$emit('deleted', id);
    },
  },
};
</script>
